import React from 'react';
import DORSigningLinkButton from './DORSigningLinkButton';
import DownloadDORButton from './DownloadDORButton';
import { languageLabels } from '../../claims/claimsHelpers';

interface LanguageOption {
  key: string;
  value: string;
}

interface DORButtonDropdownProps {
  shipmentId: number;
  trackingCode?: string;
  availableDORLanguages: string[];
  isEasyDOREnabled: boolean;
  isDORSigningLinkEnabled: boolean;
  recipientEmail: string;
  reloadSearch: () => void;
}

function DORButtonDropdown(props: DORButtonDropdownProps) {
  const {
    shipmentId,
    trackingCode,
    availableDORLanguages,
    isEasyDOREnabled,
    isDORSigningLinkEnabled,
    recipientEmail,
    reloadSearch,
  } = props;

  const mappedAvailableLanguages: LanguageOption[] = availableDORLanguages
    .map((language) => ({ key: language, value: languageLabels[language] || language.toUpperCase() }))
    .sort((a, b) => a.value.localeCompare(b.value));

  return (
    <>
      {isDORSigningLinkEnabled && (
        <DORSigningLinkButton
          languages={mappedAvailableLanguages}
          recipientEmail={recipientEmail}
          shipmentId={shipmentId}
          reloadSearch={reloadSearch}
        />
      )}
      {isEasyDOREnabled && (
        <DownloadDORButton languages={mappedAvailableLanguages} shipmentId={shipmentId} trackingCode={trackingCode} />
      )}
    </>
  );
}

export default React.memo(DORButtonDropdown);
